import { Label } from "reactstrap";
import Select, { components } from "react-select";
import { useEffect, useMemo, useState } from "react";
import { BUSINESS_URL } from "../../helpers/url_api_helper";

const normalizeBusinessItems = (items) =>
    items.map((item) => ({
      value: item.id,
      label: item.name,
    }));
const BusinessSelect = ({ value, onChange, editable }) => {
  const [business, setBusiness] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const CustomClear = (props) => (
    <components.ClearIndicator {...props}>
      <i
        className="fas fa-times"
        style={{ fontSize: "14px", color: "#888" }}
      />
    </components.ClearIndicator>
  );

  const customStyles = {
    singleValue: (base) => ({
      ...base,
      color: editable === true ? "#0576B960" : "#0576B9",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#9599AD",
      fontWeight: "400",
    }),
    control: (base, state) => ({
      ...base,
      backgroundColor: state.hasValue ? "#EFF2F7" : "#FFF",
    }),
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  useEffect(() => {
    let isMounted = true;

    const fetchBusiness = async () => {
      setLoading(true);
      setError("");

      try {
        const businessData = await BUSINESS_URL.getBusinessAll();
        if (isMounted) {
          setBusiness(normalizeBusinessItems(businessData));
        }
      } catch (error) {
        if (isMounted) {
          setError("Error fetching business");
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchBusiness();
    return () => {
      isMounted = false;
    };
  }, []);

  const selectedValue = useMemo(() => {
      if (!value) return null;
  
      return business.find(
        (business) => business.value === value.value
      ) || null;
    }, [value, business]);

  return (
    <>
      <Label className="label-filter">Business</Label>

      <Select
        className="filter-select"
        components={{ ClearIndicator: CustomClear }}
        options={business}
        value={selectedValue}
        onChange={onChange}
        placeholder={loading ? "Loading..." : "Select Business"}
        isClearable
        styles={customStyles}
        isDisabled={loading || editable}
        menuPortalTarget={document.body}
      />

      {error && <small className="text-danger">{error}</small>}
    </>
  );
};

export default BusinessSelect;
